import { useUser } from '@/app_lib/providers/UserProvider';
import type { PageAdConfig } from '@/app_lib/types/Ad';
import { createAdTagPath } from '@/app_lib/utils/ads';

export const useAdTag = (pathname: string | null, pageAdConfig?: PageAdConfig): string => {
  const { personalizedAds } = useUser();

  if (!(pageAdConfig && pathname)) {
    return '';
  }

  const adTagPath = createAdTagPath(pageAdConfig.ch, pathname);
  return (
    'pubads.g.doubleclick.net/gampad/ads' +
    `?iu=/21809533738/${adTagPath}` +
    `&description_url=${encodeURIComponent(pathname)}` +
    '&env=vp' +
    '&impl=s' +
    '&correlator=' +
    '&tfcd=0' +
    `&npa=${personalizedAds ? '0' : '1'}` +
    '&gdfp_req=1' +
    '&output=vast' +
    '&sz=640x360' +
    '&ciu_szs=300x250,728x90' +
    '&unviewed_position_start=1' +
    '&cust_params=' +
    `cid=${pageAdConfig.cid}` +
    `%26topics=${encodeURIComponent(pageAdConfig.topics?.join(',') || '')}` +
    `%26tags=${encodeURIComponent(pageAdConfig.tags?.join(',') || '')}` +
    `%26ctype=${pageAdConfig.ctype}` +
    `%26premiumCategory=${pageAdConfig.premiumCategory}`
  );
};
